<template>
  <section v-if="giveItems.length">
    <table class="table table-sm table-bordered">
      <thead class="thead-light">
        <tr>
          <th class="w-min no-br">{{ "index" | translate }}</th>
          <th>{{ "to" | translate }}</th>
          <th>{{ "merchandise_vendor" | translate }}</th>
          <th>{{ "merchandise_quantity" | translate }}</th>
          <th>{{ "transactions" | translate }}</th>
          <th>{{ "comment" | translate }}</th>
          <th v-no-print v-if="!readonly">@</th>
        </tr>
      </thead>

      <template v-for="(item, index) in giveItems">
        <tr :key="'item' + index">
          <td>{{ index + 1 }}</td>
          <td class="w-15">{{ item.to }}</td>
          <td class="w-15">{{ item.merchandiseVendor }}</td>
          <td>{{ item.merchandiseQuantity }}</td>
          <td class="w-30">
            <part-transaction-list-present
              :transactions="item.transactions"
            ></part-transaction-list-present>
          </td>
          <td class="w-15">{{ item.comment }}</td>
          <td class="w-min no-br" v-no-print v-if="!readonly">
            <a class="mr-1" href="javascript:void(0)" @click="editItem(item)">{{
              "edit" | translate
            }}</a>
            <a href="javascript:void(0)" @click="remove(index)">{{
              "remove" | translate
            }}</a>
          </td>
        </tr>
      </template>

      <tfoot>
        <tr>
          <th colspan="3">{{ "total" | translate }}</th>
          <th>{{ totalQuantity }}</th>
          <th class="text-right" colspan="2">
            <div v-for="(total, index) in totalAmounts" :key="'t' + index">
              {{ total.total | number(2) }} {{ total.currency | translate }}
            </div>
          </th>
          <th v-no-print v-if="!readonly"></th>
        </tr>
      </tfoot>
    </table>
  </section>
</template>

<script>
import { ModalService } from "@/modules/xs-modal";
import ModalGiveItemForm from "./ModalGiveItemForm";
import PartTransactionListPresent from "./PartTransactionListPresent";
import _ from "lodash";

export default {
  props: ["giveItems", "readonly"],
  data() {
    return {};
  },

  computed: {
    totalQuantity() {
      return this.giveItems.reduce((sum, item) => {
        if (item.merchandiseQuantity) {
          return sum + item.merchandiseQuantity;
        }
        return sum;
      }, 0);
    },
    totalAmounts() {
      let currencyList = [
        ...new Set(
          this.giveItems
            .flatMap(item => item.transactions)
            .map(trans => trans.currency)
        )
      ];

      return currencyList.map(curr => {
        return {
          currency: curr,
          total: this.giveItems.reduce((sum, item) => {
            return (
              sum +
              item.transactions.reduce((tSum, trn) => {
                if (trn.currency === curr) {
                  return tSum + trn.amount;
                }
                return tSum;
              }, 0)
            );
          }, 0)
        };
      });
    }
  },
  methods: {
    editItem(item) {
      ModalService.open(ModalGiveItemForm, {
        editingItem: item
      }).then(giveItem => {
        _.assign(item, giveItem);
        this.$emit("update");
      });
    },
    remove(index) {
      this.giveItems.splice(index, 1);
      this.$emit("update");
    }
  },
  components: {
    PartTransactionListPresent
  }
};
</script>
